import React from 'react';
import {LiveBadge} from '../Results/LiveBadge';
import {StepForm} from "../../models/api/codegen/code";
import {addFormatDate} from "../../utils/FormatDate";
import {StepFooter, View} from "./step-parts-components/StepFooter";
import {SportIconAndTitle} from "./step-parts-components/SportIconAndTitle";
import styled from "styled-components";
import {Info} from "./Steps";

const MainWrapper = styled.div`
    border-radius: 8px;
    margin-bottom: 10px;
    background-color: #272d33;
    font-size: 16px;
`;
MainWrapper.displayName = 'MainWrapper';

const SportIconAndTitleWrapper = styled.div`
    display: flex;
    align-items: center;
`;
SportIconAndTitleWrapper.displayName = 'SportIconAndTitleWrapper';

interface StepProps {
    step: StepForm
    view: View
}

export function OrdinarStep(props: StepProps) {

    const { step, view } = props;

    function marketTypeAndSelection() {
        return step.market + ' - ' + step.selection;
    }

    return (
        <MainWrapper>
            <div className="py-[8px] px-[10px] text-[#ffffff]">
                <div className="grid justify-between items-center grid-cols-2 text-right mb-[5px] gap-y-[8px]">
                    {step.fixture && <SportIconAndTitleWrapper>
                        <SportIconAndTitle
                            color={step.fixture.sc}
                            imageUrl={step.fixture.siu}
                            showLiveBadge={false}/>
                        <div>{step.fixture.sn}</div>
                    </SportIconAndTitleWrapper>}
                    <span>№{step.id}</span>
                    {view === "steps" && step.date && <>
                        <div/>
                        <div className="text-[14px] leading-[16px] font-normal font-['Roboto'] text-[#ABABAB]">{addFormatDate(step.date)}</div>
                    </>}
                </div>
                <div className="flex justify-between">
                    <div>
                        <div style={{fontSize: 16}}>
                            {marketTypeAndSelection()}
                        </div>
                        {<Info step={step} view={view}/>}
                    </div>
                    {step.fixture && step.fixture.s === 'LIVE' && view === 'steps' && <LiveBadge/>}
                </div>
            </div>

            <StepFooter odds={step.odds} view={view} step={step}/>

        </MainWrapper>
    );
}
